// Mirrors CreateEditJob.jsx contact field visibility (agency.type).

export function showAgencyContactFields(agencyType) {
  return agencyType !== "corporate";
}

export function showEmployerContactFields(agencyType) {
  return agencyType !== "agency" && agencyType !== "" && agencyType !== "corporate";
}

export function agencyContactFromDraft(draft) {
  return {
    name: draft?.agencyContactName || "",
    email: draft?.agencyContactEmail || "",
    phone: draft?.agencyContactPhone || "",
  };
}

export function employerContactFromDraft(draft) {
  return {
    name: draft?.employerContactName || "",
    email: draft?.employerContactEmail || "",
    phone: draft?.employerContactPhone || "",
  };
}

/** Drop contact fields that should not apply for this agency type. */
export function applyContactFieldsForAgencyType(draft, agencyType) {
  if (!draft) return draft;
  const next = { ...draft };
  if (!showAgencyContactFields(agencyType)) {
    next.agencyContactName = null;
    next.agencyContactEmail = null;
    next.agencyContactPhone = null;
  }
  if (!showEmployerContactFields(agencyType)) {
    next.employerContactName = null;
    next.employerContactEmail = null;
    next.employerContactPhone = null;
  }
  return next;
}
